// utils/getImageWithFallback.js

import { imageFallbacks } from "./imageFallbacks";



export const getImageWithFallback = (
  sources = [],
  type = "default"
) => {
  // normalize to array
  const sourceArray = Array.isArray(sources) ? sources : [sources];

  // find first valid image
  const validImage = sourceArray.find(
    (src) => typeof src === "string" && src.trim().length > 0
  );

  return validImage || imageFallbacks[type] || imageFallbacks.default;
};
